import { fetchDocument, replaceContents } from '@theme/section-renderer';

/**
 * Lazy recommendations rail: renders empty, fetches `data-url` (the recommendations endpoint with
 * `section_id`) and inserts the <product-rail> it returns. Removes itself when there is nothing to show.
 */
class ProductRecommendations extends HTMLElement {
  /** @type {AbortController | null} */
  #activeFetch = null;

  connectedCallback() {
    if (this.children.length || !this.dataset.url) return;
    this.#load(this.dataset.url);
  }

  disconnectedCallback() {
    this.#activeFetch?.abort();
    this.#activeFetch = null;
  }

  /** @param {string} url */
  async #load(url) {
    this.#activeFetch?.abort();
    const controller = new AbortController();
    this.#activeFetch = controller;
    try {
      const doc = await fetchDocument(url, { signal: controller.signal });
      const next = doc.querySelector('product-recommendations');
      if (!next || !next.children.length) {
        this.remove();
        return;
      }
      replaceContents(this, doc, 'product-recommendations');
    } catch {
      if (!controller.signal.aborted) this.remove();
    } finally {
      if (this.#activeFetch === controller) this.#activeFetch = null;
    }
  }
}

if (!customElements.get('product-recommendations')) {
  customElements.define('product-recommendations', ProductRecommendations);
}
